import {
  PortfolioAssetGroupsQuery,
  PortfolioAssetGroupsQueryNode,
  PortfolioAssetGroupsQuery$variables,
  PortfolioAssetGroupsQuery$data,
} from '@bts-web/data-layer/server';
import { gqlNetworkFetch } from '@bts-web/utils-relay';
import { fetchQueryTags } from '../fetchQueryTags';

export type PortfolioAssetGroupsResponse =
  | {
      errors: string[];
      data?: undefined;
    }
  | {
      data: PortfolioAssetGroupsQuery$data;
      errors?: undefined;
    };

export const getPortfolioAssetGroups = async (
  params: PortfolioAssetGroupsQuery$variables,
): Promise<PortfolioAssetGroupsResponse> => {
  const response = await gqlNetworkFetch<PortfolioAssetGroupsQuery>(
    PortfolioAssetGroupsQueryNode.params,
    params,
    [fetchQueryTags.portfolio, params.period.toString()],
  );

  if (response.errors && !response.data) {
    return { errors: response.errors };
  }

  return { data: response.data };
};
